/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area Chart Maker (Free, Online) — Toolverse`)
};

const es_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Área (Gratis, Online) — Toolverse`)
};

const de_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flächendiagramm-Ersteller (Kostenlos, Online) — Toolverse`)
};

const nl_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlakdiagrammaker (gratis, online) — Toolverse`)
};

const fr_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique en aires (gratuit, en ligne) — Toolverse`)
};

const it_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici ad area (gratuito, online) — Toolverse`)
};

const pt_br2_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Área (Grátis, Online) — Toolverse`)
};

const pt_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos de Área (Grátis, Online) — Toolverse`)
};

const ja_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エリアチャート作成ツール（無料・オンライン） — Toolverse`)
};

const zh_area_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面积图制作工具（免费在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_meta_title", locale)
	if (locale === "en") return en_area_meta_title(inputs)
	if (locale === "es") return es_area_meta_title(inputs)
	if (locale === "de") return de_area_meta_title(inputs)
	if (locale === "nl") return nl_area_meta_title(inputs)
	if (locale === "fr") return fr_area_meta_title(inputs)
	if (locale === "it") return it_area_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_area_meta_title(inputs)
	if (locale === "pt") return pt_area_meta_title(inputs)
	if (locale === "ja") return ja_area_meta_title(inputs)
	return zh_area_meta_title(inputs)
};